import React from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdRevenuePerView() {
  const tableData = [
    { network: "Network 1", rpm: 1.3, rpc: 0.5 },
    { network: "Network 2", rpm: 1.2, rpc: 0.4 },
    { network: "Network 3", rpm: 1.5, rpc: 0.6 },
    { network: "Network 4", rpm: 1.8, rpc: 0.8 },
    { network: "Network 5", rpm: 2.0, rpc: 1.0 },
  ];

  // Combined dataset for one chart:
  const combinedChartData = {
    labels: tableData.map((item) => item.network),
    datasets: [
      {
        label: "RPM ($ per 1000 impressions)",
        data: tableData.map((item) => item.rpm),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "RPC ($ per click)",
        data: tableData.map((item) => item.rpc),
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Network</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                name="adNetwork"
              >
                <option value="">All ad networks</option>
                <option value="network1">Network 1</option>
                <option value="network2">Network 2</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button className="btn btn-success">Reset</Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
         <h5 className="card-title">Ad Revenue per View (RPM/RPC)</h5>
              <p className="card-text">
                Revenue generated per 1,000 impressions (RPM) or per click (RPC).
              </p> 
          <div className="table-responsive">
            <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Ad Network</th>
                  <th>RPM (Revenue/1,000 Impressions)</th>
                  <th>RPC (Revenue/Click)</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.network}</td>
                    <td>${item.rpm.toFixed(2)}</td>
                    <td>${item.rpc.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {/* Combined RPM & RPC Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Revenue Metrics by Network</h6>
          <Bar data={combinedChartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdRevenuePerView;
